import { render, staticRenderFns } from "./MenuEdit.vue?vue&type=template&id=221bbea6"
import script from "./MenuEdit.vue?vue&type=script&lang=js"
export * from "./MenuEdit.vue?vue&type=script&lang=js"
import style0 from "./MenuEdit.vue?vue&type=style&index=0&id=221bbea6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports